import React from "react";
import CourbesStatChart from "./CourbesStatChart.jsx";

/**
 * Irrigation journalière : 12 courbes (horizon x statistique), via
 * CourbesStatChart. Coché à l'ouverture : Quantile 90 seulement.
 */
export default function IrrigationJournalierChart({ data, xMax }) {
  return (
    <CourbesStatChart
      data={data}
      prefixe="irr"
      cleDate="date_affichage"
      unite="mm/j"
      nomAxe="Irrigation (mm/j)"
      statsParDefaut={["q90"]}
      xMax={xMax}
    />
  );
}
